import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "space-y-4" }
const _hoisted_2 = { class: "block" }

import AppButton from "@/components/app/AppButton.vue";
import LoadingIcon from "@/components/icons/LoadingIcon.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'MintStepGenericProcessing',
  props: ["label"],
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", null, [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _createVNode(AppButton, {
      "full-width": "",
      disabled: "",
      size: "sm"
    }, {
      default: _withCtx(() => [
        _createVNode(LoadingIcon),
        _createElementVNode("span", _hoisted_2, _toDisplayString(__props.label), 1)
      ]),
      _: 1
    })
  ]))
}
}

})